import { getLeFEOrigin } from '@utils/util';

export const LbgRuleLeFE = () => (
    <iframe className="admin-iframe" title="LBG 规则管理" src={`${getLeFEOrigin()}/#/app/admin/rule`} />
);
